import { render, staticRenderFns } from "./VideoClips.vue?vue&type=template&id=4d391c28&scoped=true"
import script from "./VideoClips.vue?vue&type=script&lang=js"
export * from "./VideoClips.vue?vue&type=script&lang=js"
import style0 from "./VideoClips.vue?vue&type=style&index=0&id=4d391c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d391c28",
  null
  
)

export default component.exports